export default __webpack_public_path__ + "e31153b001b0c9e89618acfc73286161.png";